export const columns = [
  {
    title: '编号',
    dataIndex: 'id',
  },
  {
    title: '表单项',
    dataIndex: 'label',
  },
  {
    title: '排序',
    dataIndex: 'sort',
  },
  {
    title: '状态',
    customRender: (text, record)=>{
      return record.status==='0'?'禁用':'启用';
    },
  },
  {
    title: '操作',
    dataIndex: 'operation',
    scopedSlots: { customRender: 'operation' },
  },
];

export const formData = [
  {
    name: 'flag',
    lable: '配置标识',
    lableCol: 4,
    wrapperCol: 18,
    offset: 0,
    span: 24,
  },
  {
    name: 'label',
    lable: '配置名称',
    lableCol: 4,
    wrapperCol: 18,
    offset: 0,
    span: 24,
  },
  {
    name: 'sort',
    lable: '排序',
    lableCol: 4,
    wrapperCol: 18,
    offset: 0,
    span: 24,
  },
  {
    name: 'value',
    lable: '配置项集合',
    lableCol: 4,
    wrapperCol: 18,
    offset: 0,
    span: 24,
  },
];